<template>
  <div id="participants">
    <div class="content-wrapper custom-content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item custom-nav-item-cont">
            <el-input size="medium" v-model="$store.state.user.user.user.printerID" :placeholder="$t('participantManagament.attendeeList.participant.search.printerId')" class="custom-input-width" :prefix-icon="loading ? 'el-icon-loading' : 'el-icon-printer'">
              <template slot="suffix">
                <el-tooltip effect="dark" placement="top-start">
                  <div class="tooltip-wrapper" slot="content">{{ $t("participantManagament.attendeeList.participant.search.searchMsg") }}</div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
            </el-input>
          </li>
          <li class="nav-item">
            <el-button
              type="primary"
              size="mini"
              round
              icon="fas fa-plus"
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ $t("participantManagament.attendeeList.participant.search.addRegistrationCoupon") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card" @keypress.esc.exact="clearInput">
          <div class="participant-search-container">
            <el-input class="participant-search-input" ref="searchInput" id="search-input" :placeholder="$t('event.textbox.searchPID')" v-model="$store.state.participants.filter.searchTerm" :key="refreshInput" autofocus></el-input>
            <el-button
              class="participant-search-button"
              :icon="$store.state.participants.filter.searchTerm == null || $store.state.participants.filter.searchTerm == '' ? 'fas fa-search' : 'el-icon-circle-close'"
              :type="$store.state.participants.filter.searchTerm == null || $store.state.participants.filter.searchTerm == '' ? 'success' : 'danger'"
              size="medium"
              round
              @click="
                $store.state.participants.filter.searchTerm = null;
                $refs.searchInput.focus();
              "
            >
              {{ $store.state.participants.filter.searchTerm == null || $store.state.participants.filter.searchTerm == "" ? $t("participantManagament.attendeeList.participant.search.search") : $t("event.buttons.clear") }}
            </el-button>
          </div>
        </div>

        <div class="attendee-wrapper" v-if="$store.state.participants.items.length" v-loading="$store.state.participants.loading">
          <div class="attendee-list" :key="listRefresher - 'list-participants'">
            <ParticipantMini :data="prepareParticipantMini(attendee)" :selected="attendee.id == getParticipantFirstItem" v-for="attendee in $store.state.participants.items" :key="attendee.id + '-list-' + listRefresher" @setMe="setParticipant" />
          </div>
          <div class="participant-details-container">
            <transition name="el-fade-in" mode="out-in">
              <ParitcipantDetails :id="getParticipantFirstItem" v-if="getParticipantFirstItem" :key="participantKey" @refreshList="listRefresher += 1" @deletedMe="$store.state.participants.filter.searchTerm = null" />
            </transition>
          </div>
        </div>
        <div v-else-if="$store.state.participants.items.length == 0 && $store.state.participants.filter.searchTerm != null && $store.state.participants.filter.searchTerm != '' && this.$store.state.participants.loading == false">
          <HolaconLottieNoData
            class="w-100"
            key="create-loading"
            :source="'holacon-person-not-found-lottie'"
            :title="$t('participantManagament.attendeeList.participant.search.searchRegister')"
            @btnAdd="
              updateForm = null;
              modalVisible = true;
            "
            @btnRefresh="refreshParticipantSearch"
            :buttonAdd="true"
            :buttonRefresh="true"
            :loading="loading"
          />
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm == null ? $t('participantManagament.attendeeList.participant.search.addParticipant') : $t('participantManagament.attendeeList.participant.search.editParticipant')" class="large" center modal-append-to-body destroy-on-close>
      <AddUpdateParticipant v-if="modalVisible" :id="updateForm" @closeDialog="modalVisible = false" @itemCreated="participantItemCreated" />
    </el-dialog>
  </div>
</template>

<script>
import AddUpdateParticipant from "../../components/participants/AddUpdateParticipant.vue";
import ParitcipantDetails from "../../components/participants/ParticipantDetails.vue";
import ParticipantAddOrUpdate from "../../components/ParticipantAddOrUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import $ from "jquery";
import PageCountInfo from "../../components/PageCountInfo";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.search")
    };
  },
  components: { ParticipantAddOrUpdate, ExcelImport, PageCountInfo, ParitcipantDetails, AddUpdateParticipant },
  name: "Search",
  data() {
    return {
      listRefresher: +new Date(),
      refreshInput: +new Date(),
      checkList: [],
      participantKey: +new Date(),
      loading: null,
      setItem: null,
      showAccomDetails: false,
      activeTab: 1,
      activeDetails: ["1"],
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  mounted() {
    $(document).on("keydown", this.clearInput);
  },
  beforeDestroy() {
    $(document).off("keydown", this.clearInput);
  },
  methods: {
    refreshParticipantSearch() {
      this.$store.state.participants.filter.searchTerm = null;
      this.$refs.searchInput.focus();
    },
    clearInput(event) {
      if (event.keyCode === 27) {
        this.$refs.searchInput.focus();
        this.$store.state.participants.filter.searchTerm = null;
      }
    },
    setParticipant(id) {
      this.$store.commit("setParticipantFirstItem", id);
      this.participantKey += 1;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    getTag(id) {
      var attendee = this.$store.state.participants.items.find(x => x.id == id);
      var tag = this.$store.state.tags.items.find(x => x.id == attendee.tagID);
      return tag;
    },

    handleChange(val) {
      
    },
    participantItemCreated(item) {
      this.$store.state.participants.filter.searchTerm = item.participantNO;
      this.modalVisible = false;
      this.refreshInput += 1;
    },
    isDisabled(row) {
      if (row.isBlocked) {
        return "blocked";
      }
      if (row.proxyParticipant != null) {
        return "proxy";
      }
      if (row.paymentInfos.length != 0 && row.paymentInfos.some(k => k.paymentStatus == 0)) {
        return "payment";
      }
      if (row.paymentInfos.length != 0 && row.paymentInfos.some(k => k.paymentStatus == 2) && !row.paymentInfos.some(k => k.paymentStatus != 2)) {
        return "payment_cancel";
      }
      if (row.dayRestrictions != null && row.dayRestrictions.length != 0 && !row.dayRestrictions.some(k => this.$moment(k).format("LL") == this.$moment().format("LL"))) {
        return "payment_not_today";
      }
      return false;
    },
    checkIn(id) {
      this.$store.dispatch("checkIn", { id: id, context: this });
    },
    deleteSelecteds() {
      this.$prompt(this.$t("message.delete"), this.$t("message.batch"), {
        confirmButtonText: this.$t("event.buttons.delete"),
        cancelButtonText: this.$t("event.buttons.cancel"),
        inputErrorMessage: "Invalid Email",
        inputType: "password"
      }).then(({ value }) => {});
    },
    async sendVoucher(type) {
      if (type == "all") {
        var res = await axios.post("participant/load", { skip: 0, take: 1 });
        this.$store.state.voucher.total = res.data.data.total;
        this.$store.dispatch("sendVoucher", {
          ids: [],
          filter: null
        });
      }

      if (type == "selected") {
        var ids = this.$store.state.participants.selectedItems.map(k => k.id);
        this.$store.dispatch("sendVoucher", {
          ids: ids,
          filter: null
        });
      }

      if (type == "filter") {
        this.$store.state.voucher.total = this.$store.state.participants.filter.total;
        this.$store.dispatch("sendVoucher", {
          ids: [],
          filter: this.$store.state.participants.filter
        });
      }
    },
    exportExcel() {
      this.$confirm(this.$t("message.export"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("participant/export", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    exportSampleExcel() {
      this.$confirm(this.$t("message.sureCreate"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("participant/generatesample", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        participantNO: row.participantNO,
        id: row.id,
        subTagIds: row.subTagIds
      };
    },
    excelProgress(event) {
      this.excelPercent = event.percent;
    },
    itemUpdated(item) {
      var index = this.$store.state.participants.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.participants.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getParticipants");
    },
    handleSizeChange(take) {
      this.$store.commit("setParticipantTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setParticipantPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteParticipant", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleParticipant", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.state.participants.selectedItems = items;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isBlocked) {
        return "row-passive";
      } else if (row.proxyParticipant != null) {
        return "row-proxy";
      }

      return "row-active";
    },
    resetFilter() {
      this.$store.state.participants.filter = {
        ...this.$store.state.participants.filter,
        searchTerm: null,
        checkIn: null,
        isCardPrinted: null,
        voucherSendStatus: null,
        voucherTaskStatus: null,
        voucherType: null,
        activationStatus: null,
        minimumCheckInDate: null,
        maximumCheckInDate: null,
        paymentStatus: null,
        promotionIDs: null,
        tagIDs: null,
        groupIDs: null,
        activationCode: null,
        paymentType: null,
        subEventIDs: null,
        couponCode: null,
        paymentID: null,
        minCardPrintDate: null,
        maxCardPrintDate: null,
        minCheckInDate: null,
        maxCheckInDate: null,
        checkInDateRange: null,
        cardDateRange: null,
        venueMinDate: null,
        venueMaxDate: null,
        venueDateRange: null,
        venueID: null
      };
    }
  },
  async created() {
    this.$store.state.participants.loading = false;
    this.$store.state.participants.items = [];
    if (this.$store.state.participants.filter.searchTerm != "" && this.$store.state.participants.filter.searchTerm != null) {
      await this.$store.dispatch("getParticipants");
    }
  },
  computed: {
    getParticipantFirstItem() {
      return this.$store.getters.getParticipantFirstItem;
    },
    skip() {
      return (this.$store.state.participants.filter.page - 1) * this.$store.state.participants.filter.take;
    },
    take() {
      return this.skip + this.$store.state.participants.items.length;
    }
  },
  watch: {
    "$store.state.user.user.user.printerID": function(newVal) {
      if (this.loading != null) clearTimeout(this.setItem);
      this.loading = true;
      this.setItem = setTimeout(() => {
        if (newVal != null && newVal != "") {
          this.$store.dispatch("updatePrinterID", { context: this });
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, 500);
    },
    "$store.state.participants.filter.searchTerm": function(newVal) {
      this.$store.state.participants.loading = true;
      this.loading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (newVal != null && newVal != "") {
          await this.$store.dispatch("getParticipants");
          this.participantKey += 1;
        } else {
          this.$store.state.participants.loading = false;
          this.$store.state.participants.items = [];
          this.setParticipantOneId = null;
        }
        this.loading = false;
      }, 500);
    },
    "$store.state.participants.filter.venueID": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.groupIDs": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.tagIDs": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.paymentID": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
      }, 500);
    },
    "$store.state.participants.filter.couponCode": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
      }, 500);
    },
    "$store.state.participants.filter.paymentType": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.paymentStatus": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.voucherSendStatus": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.voucherType": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.voucherTaskStatus": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.activationStatus": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.activationCode": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
      }, 500);
    },
    "$store.state.participants.filter.checkIn": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.isCardPrinted": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.cardDateRange": function() {
      if (this.$store.state.participants.filter.cardDateRange != null) {
        this.$store.state.participants.filter.minCardPrintDate = this.$store.state.participants.filter.cardDateRange[0];
        this.$store.state.participants.filter.maxCardPrintDate = this.$store.state.participants.filter.cardDateRange[1];
      } else {
        this.$store.state.participants.filter.minCardPrintDate = null;
        this.$store.state.participants.filter.maxCardPrintDate = null;
      }

      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.checkInDateRange": function() {
      if (this.$store.state.participants.filter.checkInDateRange != null) {
        this.$store.state.participants.filter.minCheckInDate = this.$store.state.participants.filter.checkInDateRange[0];
        this.$store.state.participants.filter.maxCheckInDate = this.$store.state.participants.filter.checkInDateRange[1];
      } else {
        this.$store.state.participants.filter.minCheckInDate = null;
        this.$store.state.participants.filter.maxCheckInDate = null;
      }

      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.venueDateRange": function() {
      if (this.$store.state.participants.filter.venueDateRange != null) {
        this.$store.state.participants.filter.venueMinDate = this.$store.state.participants.filter.venueDateRange[0];
        this.$store.state.participants.filter.venueMaxDate = this.$store.state.participants.filter.venueDateRange[1];
      } else {
        this.$store.state.participants.filter.venueMinDate = null;
        this.$store.state.participants.filter.venueMaxDate = null;
      }

      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.selectedRegistrationInputs": function() {
      localStorage.setItem("rInputs" + this.$store.state.event.event.id, JSON.stringify(this.$store.state.participants.selectedRegistrationInputs));
    }
    //
  },
  destroyed() {
    this.$store.state.participants.filter.searchTerm = null;
  }
};
</script>

<style lang="less">
.participant-details-container {
  width: 100%;
  height: 100%;
}
.status-pending-approve {
  color: #292f3b;
  i {
    color: #50bfbf;
  }
}
.status-pending-cond-approve {
  color: #292f3b;
  i {
    color: #f98559;
  }
}
.status-pending-reject {
  color: #292f3b;
  i {
    color: #ff6565;
  }
}

.custom-content-wrapper {
  max-width: 1140px !important;

  .participant-search-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    padding: 16px 18px;

    .participant-search-input {
      & > input {
        font-size: 16px;
        border: unset;
        background-color: transparent;
      }
    }

    .participant-search-button {
      position: absolute;
      right: 20px;
    }
  }

  .attendee-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    min-height: 450px;
    gap: 10px;

    .attendee-list {
      max-width: 350px;
      min-width: 300px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      align-items: flex-start;
    }
    .attendee-details {
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
      padding: 16px 18px;
    }
  }
}

.custom-nav-item-cont {
  position: relative;
  margin-right: auto !important;

  .custom-suffix {
    position: absolute;
    right: 5px;
    top: 8px;
    i {
      font-size: 13px;
      color: #292f3b;
      font-weight: 600;
    }
  }
  .el-input__suffix {
    display: flex;
    align-items: center;

    i {
      color: #505763;
    }
  }
}
.custom-input-width {
  min-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Search.vue